import { gql } from '@apollo/client';

export const GET_ALL_FLASHCARDS = gql`
  query GetAllFlashCards {
    flashcards(order_by: { createdAt: Desc }) {
      cardData
      createdAt
      cardType
      flashcardIdentifier
      id
      flashcardusers {
        id
      }
      flashcardReviews {
        due
        state
      }
    }
  }
`;
